module.exports = __webpack_public_path__ + "img/Group 12.8113f366.png";